import { useMemo } from 'react';
import { useTranslation } from '@shared/core';

/**
 * The full regional list. An event locale is a region pack — currency and
 * distance-unit defaults derive from the region subtag (see LanguageSection's
 * LOCALE_TO_CURRENCY / IMPERIAL_CULTURES) — so regional variants that share a
 * translation bundle (e.g. en-SG, en-CA) are still meaningful choices here.
 * For translation-only pickers (guest display languages), narrow this list by
 * passing `allowedLanguageCodes` (typically SUPPORTED_LANGUAGE_CODES) to
 * LanguagePickerV2.
 */
export const useLanguageOptions = () => {
  const { tq } = useTranslation('languagePickerV2');

  return useMemo(
    () =>
      [
        { value: 'en-US', flag: '🇺🇸', label: `${tq`English (United States)`} - English (United States)` },
        { value: 'en-GB', flag: '🇬🇧', label: `${tq`English (United Kingdom)`} - English (United Kingdom)` },
        { value: 'en-IE', flag: '🇮🇪', label: `${tq`English (Ireland)`} - English (Ireland)` },
        { value: 'en-AU', flag: '🇦🇺', label: `${tq`English (Australia)`} - English (Australia)` },
        { value: 'en-NZ', flag: '🇳🇿', label: `${tq`English (New Zealand)`} - English (New Zealand)` },
        { value: 'en-SG', flag: '🇸🇬', label: `${tq`English (Singapore)`} - English (Singapore)` },
        { value: 'en-CA', flag: '🇨🇦', label: `${tq`English (Canada)`} - English (Canada)` },
        { value: 'de-DE', flag: '🇩🇪', label: `${tq`German (Germany)`} - Deutsch (Deutschland)` },
        { value: 'es-ES', flag: '🇪🇸', label: `${tq`Spanish (Spain)`} - Español (España)` },
        { value: 'es-US', flag: '🇺🇸', label: `${tq`Spanish (United States)`} - Español (Estados Unidos)` },
        { value: 'fr-FR', flag: '🇫🇷', label: `${tq`French (France)`} - Français (France)` },
        { value: 'fr-CA', flag: '🇨🇦', label: `${tq`French (Canada)`} - Français (Canada)` },
        { value: 'it-IT', flag: '🇮🇹', label: `${tq`Italian (Italy)`} - Italiano (Italia)` },
        { value: 'ja-JP', flag: '🇯🇵', label: `${tq`Japanese (Japan)`} - 日本語 (日本)` },
      ] as const,
    [tq],
  );
};
